<template>
  <div class="home-work-bench" style="min-width: 1400px">
    <div class="home-work-bench-box">
      <div class="home-work-bench-box-item">
        <div class="home-work-bench-box-item-top">
          <!-- <i class="el-icon-damai-daiban1"></i> -->
          <img src="../../assets/tip.png" alt="" style="zoom:0.4;position:absolute;top:20%;left:5%;"/>
          <div class="home-work-bench-box-item-top-info">
            <div
              class="home-work-bench-box-item-top-info-item"
              v-for="item in systemMessageList"
            >
              <div
                class="home-work-bench-box-item-top-info-item-info"
                v-html="item"
              ></div>
              <div
                class="home-work-bench-box-item-top-info-item-btn"
                @click="openedServiceVisible = true"
              >
                查看详情
              </div>
            </div>
          </div>
        </div>

        <div class="home-work-bench-box-item-bottom">
          <div class="home-work-bench-box-item-bottom-title">
            <!-- <i class="el-icon-damai-daiban"></i> -->
            <span class="darkBlue"></span>
            <div class="home-work-bench-box-item-bottom-title-tip">
              <el-badge
                :value="needDealtList.length"
                class="item"
                v-if="needDealtList.length > 0"
                >待办事项</el-badge
              >
              <div v-else>待办事项</div>
            </div>
            <div
              class="home-work-bench-box-item-bottom-title-more"
              @click="toWorkbenchApproval"
            >
              更多
            </div>
          </div>
          <div class="home-work-bench-box-item-bottom-info">
            <div class="home-work-bench-box-item-bottom-info-need-dealt-head">
              <div
                class="home-work-bench-box-item-bottom-info-need-dealt-head-item"
              >
                事项类别
              </div>
              <div
                class="home-work-bench-box-item-bottom-info-need-dealt-head-item"
              >
                提交人
              </div>
              <div
                class="home-work-bench-box-item-bottom-info-need-dealt-head-item"
              >
                发起时间
              </div>
              <div
                class="home-work-bench-box-item-bottom-info-need-dealt-head-item"
              >
                操作
              </div>
            </div>
            <div
              class="home-work-bench-box-item-bottom-info-need-dealt-body"
              v-if="needDealtList.length > 0"
            >
              <div
                class="home-work-bench-box-item-bottom-info-need-dealt-body-line"
                v-for="needDealt in needDealtList"
              >
                <div
                  class="home-work-bench-box-item-bottom-info-need-dealt-body-line-item"
                >
                  {{ needDealt.typeNameOnPage }}
                </div>
                <div
                  class="home-work-bench-box-item-bottom-info-need-dealt-body-line-item"
                >
                  {{ needDealt.personNameOnPage }}
                </div>
                <div
                  class="home-work-bench-box-item-bottom-info-need-dealt-body-line-item"
                >
                  {{ needDealt.timeOnPage }}
                </div>
                <div
                  class="home-work-bench-box-item-bottom-info-need-dealt-body-line-item home-work-bench-box-item-bottom-info-need-dealt-body-line-btn"
                  @click="toWorkbenchApprovalDetailPage(needDealt)"
                >
                  查看详情
                </div>
              </div>
            </div>
            <div class="home-work-bench-box-item-bottom-info-null" v-else>
              <img
                src="../../assets/home_png/workbench_null.png"
                alt=""
                class="home-work-bench-box-item-bottom-info-null-img"
              />
              <div class="home-work-bench-box-item-bottom-info-null-tip">
                暂无待办事项
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="home-work-bench-box-item" style="margin-left: 20px">
        <div class="home-work-bench-box-item-top">
          <!-- <i class="el-icon-damai-banben"></i> -->
          <img src="../../assets/update.png" alt="" style="zoom:0.4;position:absolute;top:20%;left:5%;" />
          <div class="more-btn" @click="showMoreUpdate">
            更多
          </div>
          <div class="home-work-bench-box-item-top-info">
            <div
              class="home-work-bench-box-item-top-info-item"
              v-for="item in versionUpdateList"
            >
              <div class="home-work-bench-box-item-top-info-item-info">
                {{ item.versionName }}
              </div>
              <div
                class="home-work-bench-box-item-top-info-item-btn"
                @click="showVersionUpdate(item)"
              >
                查看详情
              </div>
            </div>
          </div>
        </div>

        <div class="home-work-bench-box-item-bottom">
          <div class="home-work-bench-box-item-bottom-title">
            <!-- <i class="el-icon-damai-feiji"></i> -->
            <span class="darkBlue"></span>
            <div class="home-work-bench-box-item-bottom-title-tip">
              快捷入口
            </div>
            <div
              class="home-work-bench-box-item-bottom-title-more"
              @click="quickAccessChooseVisible = true"
            >
              添加
            </div>
          </div>
          <div class="home-work-bench-box-item-bottom-info">
            <div
              class="home-work-bench-box-item-bottom-info-line"
              v-if="quickAccessList.length > 0"
            >
              <div
                class="home-work-bench-box-item-bottom-info-item-box"
                v-for="item in quickAccessList"
                @click="toLinkPage(item.router, item.str, state, authCode,item.name)"
              >


                <!-- <div class="home-work-bench-box-item-bottom-info-item">
                  <img :class="flag?'animate__bounceOut':''"
                  @mouseenter="flag=true" @mouseleave="flag=false"
                    :src="item.src"
                    class="home-work-bench-box-item-bottom-info-item-img "
                  />
                  <div class="home-work-bench-box-item-bottom-info-item-name">
                    {{ item.name }}
                  </div>
                </div> -->

                  <div class="home-work-bench-box-item-bottom-info-item">
                  <img @mouseenter="changeActive($event)" @mouseleave="removeActive($event)"
                    :src="item.src"
                    class="home-work-bench-box-item-bottom-info-item-img"
                  />
                  <div class="home-work-bench-box-item-bottom-info-item-name">
                    {{ item.name }}
                  </div>
                </div>


              </div>
            </div>
            <div
              class="home-work-bench-box-item-bottom-info-null"
              v-else
            >
              <img
                src="../../assets/home_png/workbench_null.png"
                alt=""
                class="home-work-bench-box-item-bottom-info-null-img"
              />
              <div class="home-work-bench-box-item-bottom-info-null-tip">
                暂无快捷菜单
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="服务列表"
      :visible.sync="openedServiceVisible"
      width="50%"
    >
      <div>
        <div class="home-work-bench-dialog-table-head">
          <div class="home-work-bench-dialog-table-head-item">服务名称</div>
          <div class="home-work-bench-dialog-table-head-item">状态</div>
          <div class="home-work-bench-dialog-table-head-item">倒计时(天)</div>
          <div class="home-work-bench-dialog-table-head-item">开始时间</div>
          <div class="home-work-bench-dialog-table-head-item">结束时间</div>
        </div>
        <div class="home-work-bench-dialog-table-body">
          <div
            class="home-work-bench-dialog-table-body-line"
            v-for="service in openedServiceList"
          >
            <div class="home-work-bench-dialog-table-body-line-item">
              {{ service.configKey }}
            </div>
            <div class="home-work-bench-dialog-table-body-line-item">
              <div v-if="service.latestDueDate > 30">运行中</div>
              <div
                style="color: red"
                v-else-if="
                  service.latestDueDate > 0 && service.latestDueDate <= 30
                "
              >
                待续费
              </div>
              <div style="color: #999999" v-else>已到期</div>
            </div>
            <div class="home-work-bench-dialog-table-body-line-item">
              <div v-if="service.latestDueDate > 30">
                {{ service.latestDueDate }}
              </div>
              <div
                style="color: red"
                v-else-if="
                  service.latestDueDate > 0 && service.latestDueDate <= 30
                "
              >
                {{ service.latestDueDate }}
              </div>
              <div style="color: #999999" v-else>
                {{ service.latestDueDate }}
              </div>
            </div>
            <div class="home-work-bench-dialog-table-body-line-item">
              {{ service.serviceStartTime }}
            </div>
            <div class="home-work-bench-dialog-table-body-line-item">
              {{ service.serviceEndTime }}
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="primary"
          @click="openedServiceVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="versionUpdateVisibleTitle"
      :visible.sync="versionUpdateVisible"
      width="40%"
    >
      <div>
        <div style="margin: 10px 0;text-align: left;">
          {{currentVersion.publishTime}}发布
        </div>
        <div v-for="item in currentVersion.versionInfo" style="margin: 10px 0;text-align: left;">
          {{ item }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="primary"
          @click="versionUpdateVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="快捷入口配置"
      :visible.sync="quickAccessChooseVisible"
      width="1000px"
    >
      <div>
        <el-checkbox-group
          v-model="quickAccessChooseList"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <div
            style="
              height: 200px;
              flex: 1;
              line-height: 32px;
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              align-items: flex-start;
            "
            v-for="canChooseList in quickAccessCanChooseList"
            v-if="canChooseList.length > 0"
          >
            <el-checkbox
              :label="checkItem"
              :key="checkItem"
              v-for="checkItem in canChooseList"
              style="margin: 0"
            ></el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="getQuickAccessList" size="small">取 消</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="confirmChangeQuickAccessConfig"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api/Workbench";
import { nSuccess } from "../../utils/notice";
import { errorHandler } from "../../utils/errorHandler";
import { bus } from "../../utils/bus";

export default {
  name: "workbench",
  data() {
    return {
      flag: false,
      homeData: "",
      tableData: [],
      accountCode: "",
      total: 1,
      permissionCodes: "",

      systemMessageList: ["您有服务即将到期，请及时续费"],
      openedServiceList: [],
      versionUpdateList: [],
      currentVersion: {
        versionInfo: []
      },
      needDealtList: [],
      openedServiceVisible: false,
      quickAccessChooseVisible: false,
      versionUpdateVisibleTitle: "版本说明",
      versionUpdateVisible: false,
      quickAccessList: [],
      quickAccessChooseList: [],
      quickAccessCanChooseList: [],
      quickAccessAllList: [
        {
          name: "公告资讯",
          src: require("../../assets/home_png/ggzx.png"),
          router: "yq-notice-management",
          authCode: "001002000",
          str: "resource",
          isShow: false
        },
        {
          name: "房产管理",
          src: require("../../assets/home_png/fcgl.png"),
          router: "housing-management",
          authCode: "001003000",
          str: "resource",
          isShow: false
        },
        {
          name: "承租管理",
          src: require("../../assets/home_png/qygl.png"),
          router: "lessee-management",
          authCode: "001004000",
          str: "resource",
          isShow: false
        },
        // {
        //   name: "智慧大脑",
        //   src: require("../../assets/home_png/zhdn.png"),
        //   router: "interface-manage",
        //   authCode: "028",
        //   str: "application",
        //   isShow: false
        // },
        {
          name: "智慧合约",
          src: require("../../assets/home_png/zhzs.png"),
          router: "investment-over-view",
          authCode: "002",
          str: "application",
          isShow: false
        },
        // {
        //   name: "智慧招商",
        //   src: require("../../assets/home_png/zhjjr.png"),
        //   router: "investment-manage",
        //   authCode: "017",
        //   str: "application",
        //   isShow: false
        // },
        {
          name: "智慧消息",
          src: require("../../assets/home_png/zhxx.png"),
          router: "message-template-manage",
          authCode: "006",
          str: "application",
          isShow: false
        },
        // {
        //   name: "智慧文书",
        //   src: require("../../assets/home_png/zhws.png"),
        //   router: "contract-template",
        //   authCode: "015",
        //   str: "application",
        //   isShow: false
        // },

        {
          name: "智慧访客",
          src: require("../../assets/home_png/zhfk.png"),
          router: "visitor-over-view",
          authCode: "007",
          str: "application",
          isShow: false
        },
        {
          name: "智慧门禁",
          src: require("../../assets/home_png/zhmj.png"),
          router: "accessCtrlDeviceManagementCenter",
          authCode: "003",
          str: "application",
          isShow: false
        },
        {
          name: "智慧门锁",
          src: require("../../assets/home_png/zhmj.png"),
          router: "lock-concentrator-manage",
          authCode: "056",
          str: "application",
          isShow: false
        },
        {
          name: "智慧梯控",
          src: require("../../assets/home_png/zhtk.png"),
          router: "ladder-over-view",
          authCode: "009",
          str: "application",
          isShow: false
        },
        {
          name: "智慧停车",
          src: require("../../assets/home_png/zhtc.png"),
          router: "park-over-view",
          authCode: "004",
          str: "application",
          isShow: false
        },

        // {
        //   name: "智慧活动",
        //   src: require("../../assets/home_png/zhhd.png"),
        //   router: "activity-manage",
        //   authCode: "019",
        //   str: "application",
        //   isShow: false
        // },
        // {
        //   name: "智慧预约",
        //   src: require("../../assets/home_png/zhyy.png"),
        //   router: "site-over-view",
        //   authCode: "008",
        //   str: "application",
        //   isShow: false
        // },
        // {
        //   name: "严选服务",
        //   src: require("../../assets/home_png/yxfw.png"),
        //   router: "service-over-view",
        //   authCode: "018",
        //   str: "application",
        //   isShow: false
        // },

        {
          name: "智慧报修",
          src: require("../../assets/home_png/zhbx.png"),
          router: "repair-over-view",
          authCode: "011",
          str: "application",
          isShow: false
        },
        {
          name: "智慧巡更",
          src: require("../../assets/home_png/zhxg.png"),
          router: "patrol-point-manage",
          authCode: "025",
          str: "application",
          isShow: false
        },
        {
          name: "设备巡检",
          src: require("../../assets/home_png/sbxj.png"),
          router: "inspection-device-type-manage",
          authCode: "024",
          str: "application",
          isShow: false
        },
        {
          name: "智慧考勤",
          src: require("../../assets/home_png/zhws.png"),
          router: "attendance-department-manage",
          authCode: "034",
          str: "application",
          isShow: false
        },
        // {name: '智能机器人', src: require('../../assets/home_png/znjqr.png'), router: '', authCode: '', str: 'application', isShow: false},

        {
          name: "智慧财务",
          src: require("../../assets/home_png/zhcw.png"),
          router: "finance-over-view",
          authCode: "013",
          str: "application",
          isShow: false
        },
        {
          name: "智慧收费",
          src: require("../../assets/home_png/zhjf.png"),
          router: "charge-items-management",
          authCode: "014",
          str: "application",
          isShow: false
        },
        {
          name: "智慧凭证",
          src: require("../../assets/home_png/zhfp.png"),
          router: "invoice-over-view",
          authCode: "016",
          str: "application",
          isShow: false
        },

        {
          name: "智慧用电",
          src: require("../../assets/home_png/zhyd.png"),
          router: "electronic-over-view",
          authCode: "005",
          str: "application",
          isShow: false
        },
        {
          name: "智慧用水",
          src: require("../../assets/home_png/zhys.png"),
          router: "water-over-view",
          authCode: "027",
          str: "application",
          isShow: false
        },
        // {
        //   name: "智慧空调",
        //   src: require("../../assets/home_png/zhkt.png"),
        //   router: "air-conditioning-gateway-device",
        //   authCode: "023",
        //   str: "application",
        //   isShow: false
        // },

        // {
        //   name: "智慧监控",
        //   src: require("../../assets/home_png/zhjk.png"),
        //   router: "video-device",
        //   authCode: "020",
        //   str: "application",
        //   isShow: false
        // },
        // {
        //   name: "智慧消防",
        //   src: require("../../assets/home_png/zhxf.png"),
        //   router: "fire-over-view",
        //   authCode: "021",
        //   str: "application",
        //   isShow: false
        // },
        // {
        //   name: "报警中心",
        //   src: require("../../assets/home_png/bjzx.png"),
        //   router: "alarm-device-manage",
        //   authCode: "022",
        //   str: "application",
        //   isShow: false
        // }
      ],

      quickAccessAllList1: [
        {
          name: "公告资讯",
          src: require("../../assets/home_png/ggzx.png"),
          router: "yq-notice-management",
          authCode: "001002000",
          str: "resource",
          isShow: false
        },
        {
          name: "房产管理",
          src: require("../../assets/home_png/fcgl.png"),
          router: "housing-management",
          authCode: "001003000",
          str: "resource",
          isShow: false
        },
        {
          name: "承租管理",
          src: require("../../assets/home_png/qygl.png"),
          router: "lessee-management",
          authCode: "001004000",
          str: "resource",
          isShow: false
        }
      ],
      quickAccessAllList2: [
        // {
        //   name: "智慧大脑",
        //   src: require("../../assets/home_png/zhdn.png"),
        //   router: "interface-manage",
        //   authCode: "028",
        //   str: "application",
        //   isShow: false
        // },
        {
          name: "智慧合约",
          src: require("../../assets/home_png/zhzs.png"),
          router: "investment-over-view",
          authCode: "002",
          str: "application",
          isShow: false
        },
        // {
        //   name: "智慧招商",
        //   src: require("../../assets/home_png/zhjjr.png"),
        //   router: "investment-manage",
        //   authCode: "017",
        //   str: "application",
        //   isShow: false
        // },
        // {
        //   name: "智慧活动",
        //   src: require("../../assets/home_png/zhhd.png"),
        //   router: "activity-manage",
        //   authCode: "019",
        //   str: "application",
        //   isShow: false
        // },
        {
          name: "智慧消息",
          src: require("../../assets/home_png/zhxx.png"),
          router: "message-template-manage",
          authCode: "006",
          str: "application",
          isShow: false
        },
        {
          name: "智慧报修",
          src: require("../../assets/home_png/zhbx.png"),
          router: "repair-over-view",
          authCode: "011",
          str: "application",
          isShow: false
        },
        {
          name: "智慧巡更",
          src: require("../../assets/home_png/zhxg.png"),
          router: "patrol-point-manage",
          authCode: "025",
          str: "application",
          isShow: false
        },
        {
          name: "设备巡检",
          src: require("../../assets/home_png/sbxj.png"),
          router: "inspection-device-type-manage",
          authCode: "024",
          str: "application",
          isShow: false
        },
        {
          name: "智慧考勤",
          src: require("../../assets/home_png/zhws.png"),
          router: "attendance-department-manage",
          authCode: "034",
          str: "application",
          isShow: false
        },
        // {
        //   name: "智慧文书",
        //   src: require("../../assets/home_png/zhws.png"),
        //   router: "contract-template",
        //   authCode: "015",
        //   str: "application",
        //   isShow: false
        // }
      ],
      quickAccessAllList3: [
        {
          name: "智慧用电",
          src: require("../../assets/home_png/zhyd.png"),
          router: "electronic-over-view",
          authCode: "005",
          str: "application",
          isShow: false
        },
        {
          name: "智慧用水",
          src: require("../../assets/home_png/zhys.png"),
          router: "water-over-view",
          authCode: "027",
          str: "application",
          isShow: false
        },
      ],
      quickAccessAllList4: [
        {
          name: "智慧财务",
          src: require("../../assets/home_png/zhcw.png"),
          router: "finance-over-view",
          authCode: "013",
          str: "application",
          isShow: false
        },
        {
          name: "智慧收费",
          src: require("../../assets/home_png/zhjf.png"),
          router: "charge-items-management",
          authCode: "014",
          str: "application",
          isShow: false
        },
        {
          name: "智慧凭证",
          src: require("../../assets/home_png/zhfp.png"),
          router: "invoice-over-view",
          authCode: "016",
          str: "application",
          isShow: false
        }
        // {
        //   name: "智慧空调",
        //   src: require("../../assets/home_png/zhkt.png"),
        //   router: "air-conditioning-gateway-device",
        //   authCode: "023",
        //   str: "application",
        //   isShow: false
        // }
      ],
      quickAccessAllList5: [
      ],
      quickAccessAllList6: [
        {
          name: "智慧门禁",
          src: require("../../assets/home_png/zhmj.png"),
          router: "accessCtrlDeviceManagementCenter",
          authCode: "003",
          str: "application",
          isShow: false
        },
        {
          name: "智慧门锁",
          src: require("../../assets/home_png/zhmj.png"),
          router: "lock-concentrator-manage",
          authCode: "056",
          str: "application",
          isShow: false
        },
        {
          name: "智慧停车",
          src: require("../../assets/home_png/zhtc.png"),
          router: "park-over-view",
          authCode: "004",
          str: "application",
          isShow: false
        },
        {
          name: "智慧梯控",
          src: require("../../assets/home_png/zhtk.png"),
          router: "ladder-over-view",
          authCode: "009",
          str: "application",
          isShow: false
        },
        {
          name: "智慧访客",
          src: require("../../assets/home_png/zhfk.png"),
          router: "visitor-over-view",
          authCode: "007",
          str: "application",
          isShow: false
        }
      ],
      quickAccessAllList7: [
        // {
        //   name: "智慧监控",
        //   src: require("../../assets/home_png/zhjk.png"),
        //   router: "video-device",
        //   authCode: "020",
        //   str: "application",
        //   isShow: false
        // },
        // {
        //   name: "智慧消防",
        //   src: require("../../assets/home_png/zhxf.png"),
        //   router: "fire-over-view",
        //   authCode: "021",
        //   str: "application",
        //   isShow: false
        // },
        // {
        //   name: "报警中心",
        //   src: require("../../assets/home_png/bjzx.png"),
        //   router: "alarm-device-manage",
        //   authCode: "022",
        //   str: "application",
        //   isShow: false
        // }
      ],
      quickAccessAllList8: [
        // {
        //   name: "严选服务",
        //   src: require("../../assets/home_png/yxfw.png"),
        //   router: "service-over-view",
        //   authCode: "018",
        //   str: "application",
        //   isShow: false
        // },
        // {
        //   name: "智慧预约",
        //   src: require("../../assets/home_png/zhyy.png"),
        //   router: "site-over-view",
        //   authCode: "008",
        //   str: "application",
        //   isShow: false
        // }
      ],
      quickAccessAllList9: []
    };
  },
  created() {
    this.accountCode = bus.global.accountCode;
    this.permissionCodes = bus.global.permissionCodes.split(",");
    let quickAccessCanChooseList = [[], [], [], [], [], [], [], [], []];
    let quickAccessAllList = [
      this.quickAccessAllList1,
      this.quickAccessAllList2,
      this.quickAccessAllList3,
      this.quickAccessAllList4,
      this.quickAccessAllList5,
      this.quickAccessAllList6,
      this.quickAccessAllList7,
      this.quickAccessAllList8,
      this.quickAccessAllList9
    ];
    quickAccessAllList.map((value, valueIndex) => {
      value.map(v => {
        if (this.permissionCodes.indexOf(v.authCode) !== -1) {
          v.isShow = true;
          quickAccessCanChooseList[valueIndex].push(v.name);
        }
      });
    });
    this.quickAccessAllList.map(v => {
      if (this.permissionCodes.indexOf(v.authCode) !== -1) {
        v.isShow = true;
      }
    });
    this.quickAccessCanChooseList = quickAccessCanChooseList;
    this.getVesionPage();
    this.getYqServerConfig();
    this.getQuickAccessList();
    this.getWorkbenchList();
  },
  mounted() {},
  methods: {
    //11
    changeActive($event) {
      $event.currentTarget.className = "active1";
    },
    removeActive($event) {
      $event.currentTarget.className = "";
    },

    // 页面跳转
    toLinkPage(routerName, str, state, authCode,title) {
      window.sessionStorage.setItem("navTop", str);
      if(title)window.sessionStorage.setItem('currentRouterTitle',title)
      this.$router.push({
        name: routerName
      });
    },

    // 获取版本信息
    getVesionPage() {
      this.$axios
        .post(api.getVesionPage, {
          pageNum: "1",
          pageSize: "3"
        })
        .then(res => {
          let data = res.data.data.list || [];
          data.map(v => {
            v.versionInfo = v.versionDes.split("\n") || [];
          });
          this.versionUpdateList = data;
        })
        .catch(errorHandler("获取版本信息失败"));
    },

    showVersionUpdate(versionInfo) {
      this.currentVersion = versionInfo;
      this.versionUpdateVisibleTitle = versionInfo.versionName;
      this.versionUpdateVisible = true;
    },

    // 获取服务配置数据
    getYqServerConfig() {
      this.$axios
        .post(api.getYqServerConfig, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            let openedServiceList = [];
            let latestDueDateTimestamp = 0;
            let currentTimestamp = new Date().getTime();
            data.map((v, i) => {
              if (v.configStatus === "1") {
                openedServiceList.push(v);
                if (v.serviceEndTime) {
                  let itemTimestamp = new Date(v.serviceEndTime).getTime();
                  let timeDifference = itemTimestamp - currentTimestamp;
                  v.latestDueDate = Math.ceil(timeDifference / 86400000);
                  if (!latestDueDateTimestamp) {
                    latestDueDateTimestamp = timeDifference;
                  } else {
                    if (timeDifference < latestDueDateTimestamp) {
                      latestDueDateTimestamp = timeDifference;
                    }
                  }
                }
              }
            });
            let latestDueDate = Math.ceil(latestDueDateTimestamp / 86400000);
            if (latestDueDate > 0) {
              this.systemMessageList = [
                `您有服务将在<span style="color: #C11C1C;font-weight: 900;margin: 0 3px;">${latestDueDate}</span>天后到期，请及时续费`
              ];
            } else {
              this.systemMessageList = [
                `您有服务<span style="color: #C11C1C;font-weight: 900;">已到期</span>，请及时续费`
              ];
            }
            this.openedServiceList = openedServiceList.sort(
              this.serviceSort("latestDueDate")
            );
          }
        })
        .catch(errorHandler("查询公寓服务状态失败"));
    },

    serviceSort(property) {
      return function(a, b) {
        let value1 = a[property];
        let value2 = b[property];
        return value1 - value2;
      };
    },

    getWorkbenchList() {
      this.$axios
        .post(api.getWorkbenchList, {
          accountCode: this.accountCode
        })
        .then(res => {
          let data = res.data.data;
          let needDealtList = [], suggestion = data.suggestion || [], lease = data.lease || [], electric = data.electric || [], attendance = data.attendance || [],
          bill = data.bill || [], water = data.water || [], hatch = data.hatch || [], appLease = data.appLease || [], returnLease = data.returnLease || [],
          repair = data.repair || [], stayApply = data.stayApply || [], free = data.free || [];
          // 投诉建议
          suggestion.map(v => {
            v.typeNameOnPage = "投诉建议";
            v.personNameOnPage = v.personName;
            needDealtList.push(v);
          });
          // 合同审批
          lease.map(v => {
            v.typeNameOnPage = "合同审批";
            v.personNameOnPage = v.sponsorAccountName;
            needDealtList.push(v);
          });
          // 电费充值审批
          electric.map(v => {
            v.typeNameOnPage = "电费充值审批";
            v.personNameOnPage = v.sponsorAccountName;
            needDealtList.push(v);
          });
          // 考勤审批
          attendance.map(v => {
            v.typeNameOnPage = "考勤审批";
            v.personNameOnPage = v.sponsorAccountName;
            needDealtList.push(v);
          });
          // 账单修改审批
          bill.map(v => {
            v.typeNameOnPage = "账单修改审批";
            v.personNameOnPage = v.sponsorAccountName;
            needDealtList.push(v);
          });
          // 水费充值审批
          water.map(v => {
            v.typeNameOnPage = "水费充值审批";
            v.personNameOnPage = v.sponsorAccountName;
            needDealtList.push(v);
          });
          // 孵化审批
          hatch.map(v => {
            v.typeNameOnPage = "孵化审批";
            v.personNameOnPage = v.sponsorAccountName;
            needDealtList.push(v);
          });
          // 车位申请
          appLease.map(v => {
            v.typeNameOnPage = "车位申请审批";
            v.personNameOnPage = v.sponsorAccountName;
            needDealtList.push(v);
          });
          // 车位退还
          returnLease.map(v => {
            v.typeNameOnPage = "车位退还审批";
            v.personNameOnPage = v.sponsorAccountName;
            needDealtList.push(v);
          });
          // 报修审批
          repair.map(v => {
            v.typeNameOnPage = "报修审批";
            v.personNameOnPage = v.personName;
            needDealtList.push(v);
          });
          // 入住申请审批
          stayApply.map(v => {
            v.typeNameOnPage = "入住申请审批";
            v.personNameOnPage = v.personName;
            needDealtList.push(v);
          });
          // 免费码授权人审批
          free.map(v => {
            v.typeNameOnPage = "免费码授权人审批";
            v.personNameOnPage = v.personName;
            needDealtList.push(v);
          });
          needDealtList.map(v => {
            if (v.sponsorDate) {
              v.timeOnPage = v.sponsorDate;
            } else if (v.createTime) {
              v.timeOnPage = v.createTime.slice(0, 19);
            } else {
              v.timeOnPage = "";
            }
          });
          this.needDealtList = needDealtList;
        })
        .catch(errorHandler("获取待办数据失败"));
    },

    buildingRowClick(row) {
      window.sessionStorage.setItem(
        "housingManagementPageBuildingTabState",
        row.code
      );
      window.sessionStorage.setItem(
        "housingManagementPageHousingTabState",
        "housing_resources"
      );
      window.sessionStorage.setItem("navTop", "resource");
      this.$router.push({
        name: "housing-management"
      });
    },

    toWorkbenchApproval() {
      this.$router.push({
        name: "contract-approval"
      });
    },

    toWorkbenchApprovalDetailPage(needDealt) {
      if (needDealt.typeNameOnPage === "投诉建议") {
        this.$router.push({
          name: "suggestion-approval"
          // path: `/user_center/suggestions_details/${needDealt.code}`,
        });
      } else if (needDealt.typeNameOnPage === "合同审批") {
        sessionStorage.setItem("workDetailData", JSON.stringify(needDealt));
        sessionStorage.setItem("workDetailActiveName", "pendingApproval");
        this.$router.push({
          name: "contract-approval"
        });
      } else if (needDealt.typeNameOnPage === "电费充值审批") {
        this.$router.push({
          name: "electricity-approval"
        });
      } else if (needDealt.typeNameOnPage === "水费充值审批") {
        this.$router.push({
          name: "water-approval"
        });
      } else if (needDealt.typeNameOnPage === "考勤审批") {
        this.$router.push({
          name: "attendance-approval"
        });
      } else if (needDealt.typeNameOnPage === "车位申请审批") {
        this.$router.push({
          name: "parking-apply-approval"
        });
      } else if (needDealt.typeNameOnPage === "车位退还审批") {
        this.$router.push({
          name: "parking-back-approval"
        });
      } else if (needDealt.typeNameOnPage === "账单修改审批") {
        this.$router.push({
          name: "revise-approval"
        });
      } else if (needDealt.typeNameOnPage === "孵化审批") {
        sessionStorage.setItem(
          "hatchWorkDetailData",
          JSON.stringify(needDealt)
        );
        sessionStorage.setItem(
          "hatchWorkDetailActiveName",
          "hatchPendingApproval"
        );
        this.$router.push({
          name: "hatch-approval"
        });
      } else if (needDealt.typeNameOnPage === "报修审批") {
        this.$router.push({
          name: "repair-approval"
        });
      } else if (needDealt.typeNameOnPage === "入住申请审批") {
        this.$router.push({
          name: "occupancy-approval"
        });
      } else if (needDealt.typeNameOnPage === "免费码授权人审批") {
        this.$router.push({
          name: "free-code-approval"
        });
      }
    },

    // 获取已配置的快捷入口 暂时用permissionCodes
    getQuickAccessList() {
      this.$axios
        .post(api.getQuickAccessList, {
          accountCode: this.accountCode
        })
        .then(res => {
          let data = res.data.data;
          let menus = data.menus || "";
          let menusArr = menus.split(",") || [];
          let quickAccessList = [];
          let quickAccessChooseList = [];
          menusArr.map(code => {
            this.quickAccessAllList.map(quick => {
              if (quick.authCode === code && quick.isShow) {
                quickAccessList.push(quick);
                quickAccessChooseList.push(quick.name);
              }
            });
          });
          this.quickAccessList = quickAccessList;
          this.quickAccessChooseList = quickAccessChooseList;
          this.quickAccessChooseVisible = false;
        })
        .catch(errorHandler("获取快捷菜单失败"));
    },

    // 修改配置快捷菜单
    confirmChangeQuickAccessConfig() {
      let quickAccessChooseCodeList = [];
      this.quickAccessAllList.map(v => {
        if (this.quickAccessChooseList.indexOf(v.name) !== -1) {
          quickAccessChooseCodeList.push(v.authCode);
        }
      });
      // if (quickAccessChooseCodeList.length === 0) {
      //   return false;
      // }
      this.$axios
        .post(api.configQuickAccessList, {
          accountCode: this.accountCode,
          menus: quickAccessChooseCodeList.join(",")
        })
        .then(res => {
          nSuccess("配置成功");
          this.getQuickAccessList();
        })
        .catch(errorHandler("配置失败"));
    },

    showMoreUpdate(){
      this.$router.push({
        path:`/update_detail`
      })
    }
  },
  watch: {}
};
</script>

<style lang="less">
.home-work-bench {
  .home-work-bench-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1% 20px;
    .home-work-bench-box-item {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      .home-work-bench-box-item-top {
        background: url("../../assets/home_png/bg_blue.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 100%;
        position:relative;
        //height: 100px;
        flex:1;
        margin-bottom: 20px;
        padding: 0 10px;
        border-radius: 5px;
        border: 1px solid #dcdfe6;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
          0 0 6px 0 rgba(0, 0, 0, 0.04);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        overflow: hidden;
        i {
          width: 10%;
          font-size: 42px;
          background-image: -webkit-linear-gradient(bottom, #00a0e6, #00a0e699);
          -webkit-background-clip: text;
          color: transparent;
        }
        .home-work-bench-box-item-top-info {
          width: 90%;
          margin-top:70px;
          height:50%;
          flex: 1;
          .home-work-bench-box-item-top-info-item {
            margin: 5px 0;
            text-align: left;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 15px;
            .home-work-bench-box-item-top-info-item-info {
              width: 60%;
              font-size: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-left:80px
            }
            .home-work-bench-box-item-top-info-item-btn {
              // color: #00a0e6;
              // cursor: pointer;
              width: 70px;
              height: 24px;
              background: #1362ff;
              opacity: 1;
              border-radius: 7px;
              color: #fff;
              line-height: 24px;
              cursor: pointer;
              text-align: center;
              font-size: 12px;
            }
          }
        }
      }
      .home-work-bench-box-item-bottom {
        flex: 2;
        border-radius: 5px;
        border: 1px solid #dcdfe6;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
          0 0 6px 0 rgba(0, 0, 0, 0.04);
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .home-work-bench-box-item-bottom-title {
          padding: 20px 10px 10px;
          // background-color: #f3f3f3;
          display: flex;
          justify-content: space-between;
          align-items: center;
          i {
            width: 10%;
            font-size: 42px;
            background-image: -webkit-linear-gradient(
              bottom,
              #00a0e6,
              #00a0e699
            );
            -webkit-background-clip: text;
            color: transparent;
          }
          .home-work-bench-box-item-bottom-title-tip {
            margin: 0 10px 0 0;
            flex: 1;
            text-align: left;
            font-size: 16px;
            font-weight: 600;
          }
          .home-work-bench-box-item-bottom-title-more {
            width: 70px;
            height: 24px;
            background: #1362ff;
            opacity: 1;
            border-radius: 7px;
            color: #fff;
            line-height: 24px;
            cursor: pointer;
            font-size: 12px;
          }
        }
        .home-work-bench-box-item-bottom-info {
          margin-top: 10px;
          padding: 0 10px;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          flex: 1;
          .home-work-bench-box-item-bottom-info-need-dealt-head {
            background-color: #eff1f5;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-weight: bold;
            .home-work-bench-box-item-bottom-info-need-dealt-head-item {
              flex: 1;
              line-height: 24px;
              padding: 10px 0;
            }
          }
          .home-work-bench-box-item-bottom-info-need-dealt-body {
            border-bottom: 1px solid #eff1f5;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            height: 300px;
            overflow-y: auto;
            .home-work-bench-box-item-bottom-info-need-dealt-body-line {
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1px solid #eff1f5;
              .home-work-bench-box-item-bottom-info-need-dealt-body-line-item {
                flex: 1;
                line-height: 24px;
                padding: 10px 0;
              }
              .home-work-bench-box-item-bottom-info-need-dealt-body-line-btn {
                color: #00a0e6;
                cursor: pointer;
              }
            }
          }
          .home-work-bench-box-item-bottom-info-line {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            .home-work-bench-box-item-bottom-info-item-box {
              width: 25%;
              text-align: center;
              .home-work-bench-box-item-bottom-info-item {
                width: 80px;
                height: 80px;
                margin: 20px auto;
                cursor: pointer;
                // // border: 1px solid #dcdfe6;
                // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
                //   0 0 6px 0 rgba(0, 0, 0, 0.04);
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                .home-work-bench-box-item-bottom-info-item-img {
                  // width: 100%;
                  // height: 100%;
                }
                .home-work-bench-box-item-bottom-info-item-name {
                  font-size: 14px;
                  line-height: 25px;
                }
              }
              //11
              // .home-work-bench-box-item-bottom-info-item:hover {
              // }
            }
          }
          .home-work-bench-box-item-bottom-info-null {
            margin: 60px auto;
            .home-work-bench-box-item-bottom-info-null-img {
              width: 332px;
              height: 200px;
            }
            .home-work-bench-box-item-bottom-info-null-tip {
              color: #999999;
            }
          }
        }
      }
    }
  }
  .home-work-bench-dialog-table-head {
    background-color: #eff1f5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    .home-work-bench-dialog-table-head-item {
      flex: 1;
      line-height: 24px;
      padding: 10px 0;
    }
  }
  .home-work-bench-dialog-table-body {
    border-bottom: 1px solid #eff1f5;
    .home-work-bench-dialog-table-body-line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eff1f5;
      .home-work-bench-dialog-table-body-line-item {
        flex: 1;
        line-height: 24px;
        padding: 10px 0;
      }
      .home-work-bench-dialog-table-body-line-btn {
        color: #00a0e6;
        cursor: pointer;
      }
    }
  }
}
.darkBlue {
  width: 7px;
  height: 22px;
  background: #1362ff;
  opacity: 1;
  border-radius: 5px;
  margin-right: 8px;
}
.active1 {
  transform: rotateY(360deg);
  transition: 1s;
}
.home-work-bench-box-item-top {
  margin-top: 20px;
}

.more-btn{
  width: 70px;
  height: 24px;
  background: #1362ff;
  opacity: 1;
  border-radius: 7px;
  color: #fff;
  line-height: 24px;
  cursor: pointer;
  font-size: 12px;
  position:absolute;
  top:27%;
  right:10px;
}
</style>



// WEBPACK FOOTER //
// src/view/Workbench/Workbench_3.vue